import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formattedViews =
    comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views;

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 汗汗漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-background-50 text-xs font-medium whitespace-nowrap">
            立即阅读
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="text-xs px-1.5 py-0.5 rounded bg-background-950/70 text-accent-400 font-medium whitespace-nowrap">
            {comic.rating}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
        {comic.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{comic.author}</span>
        <span>·</span>
        <span>{formattedViews}阅读</span>
      </div>
    </Link>
  );
}